export default __webpack_public_path__ + "static/media/line_gray_tick.2ef0d1d8.svg";